export type SelectorValue = string;

export interface SelectorItemType {
	label: string;
	value: SelectorValue;
	icon?: React.ReactNode;
	description?: string;
}

export enum SelectType {
	Multiple = 'multiple',
	Single = 'single',
}
